export class Panorama {
    id: number;
    key: string;
    constructor(data?: Panorama) {
        this.id = data?.id ?? 0;
        this.key = data?.key ?? "";
    }
}

export const panoramas = [
    new Panorama({
        id: 0,
        key: 'most',
    }),
    new Panorama({
        id: 1,
        key: 'moskovskiy',
    }),
    new Panorama({
        id: 2,
        key: 'vspolie',
    }),
    new Panorama({
        id: 3,
        key: 'bui',
    }),
    new Panorama({
        id: 4,
        key: 'vologda',
    }),
    new Panorama({
        id: 5,
        key: 'cherepovec',
    }),
]